export default "__VITE_ASSET__CXIDMJ19__"